import React, { Component } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';

import { ConsultTipEv, AddItem, GuardarTeHist, GuardarNotaHist, ConsultLiterales } from "../../../funciones/HistoricoFunction";

class MateriaHistApl extends Component {
    state = { 
        periodo: this.props.datos.periodo,
        nota: this.props.datos.nota,
        enLetras: "",
        valorTe: { value: '', label: '- Selecciona un Tipo de Evaluación -' },
        TeDisp: [{ value: '', label: '- Cargando -' }],
        periodoSelect: {value:"", label: "- Selecciona un Periodo -"},
        periodos: this.props.periodos,
        notaSelect: { value: '', label: '- Nota -' },
        literales: [],
    }

    constructor (props) {
        super (props)
        let valor = {
            id: this.props.datos.teid,
            tipoev_name: this.props.datos.tipoev_name
        }

        ConsultTipEv (valor, (resp) => {
            this.setState({
                TeDisp: resp[0],
                valorTe: resp[1]
            })
        })

        if ((this.props.datos.cuantitativo) === 0){
            
            ConsultLiterales ((resp) => {
                this.setState({
                    literales: resp,
                    notaSelect: resp[parseInt(this.state.nota) - 1]
                })
            })
        }
    }

    componentDidMount = () => {
        if(this.props.datos.nota !== "") this.setState ({
            /* check: true,
            openDelMat: false */
        }, () => {
            this.enLetras();
            this.updValorPeriodo(this.props.datos.periodo, this.props.datos.corte_name, this.props.datos.corte_year)
        })
    }

    updValorPeriodo = (id, mes, yyyy) => {
        let meses = (mes) => {
            let mesN = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
            return mesN[mes - 1]
        }
        let contenido = {value: id, label: `${meses(mes)} ${yyyy}`}

        this.setState({periodoSelect: contenido})
    }

    valorPeriodo = (periodoSelect) => {
        this.setState({
            periodoSelect
        }, () => {
            this.guardarPeriodo()
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:(event.target.value).toUpperCase(),
        });
    };

    tabEnter = (campo) => (e) => {
        let { num, cantidad } = this.props;
        if (e.which === 13){
            let next = num + 1;
            
            for (let i = 1; i < cantidad; i++){
                if (document.getElementById(`${campo}${next}`) === null) next ++;
            }

            if (document.getElementById(`${campo}${next}`) === null) return null;
            document.getElementById(`${campo}${next}`).focus();
        };
    }

    guardarPeriodo = () => {
        let { datos, est } = this.props;
        this.props.preloader();
        
        AddItem(this.state.periodoSelect.value, "periodo", est, datos.hid,  (resp) => {
            if(resp.errores > 0) {
                toast[resp.tipo](resp.mess,{autoClose: 4000});
                this.props.preloaderNok();
            }else{
                this.props.preloaderOk();
            }
        })
    }

    periodo = () => {
        let { datos, num } = this.props;
        let { periodoSelect, periodos } = this.state;

        const customStyles = (base) => ({
            ...base,
            fontSize: 10,
        });

        if (datos.periodo !== "")  return (
            <Select
                styles={{menu: customStyles}}
                isSearchable ={true}
                value={periodoSelect}
                onChange={this.valorPeriodo}
                options={periodos}
            />
            /* <input className="form-control" id = {`notaPeriodoApl_${num}`} onKeyPress={this.tabEnter("notaPeriodoApl_")} onBlur = {() => {this.guardarPeriodo()}} onChange={this.cambiaValor("periodo")} type= "text" value={this.state.periodo} title="Agregar un periodo al estudiante"/> */
        )
    }

    valorSelectTe = (valorTe) => {
        let { datos, est } = this.props;
        this.props.preloader();

        this.setState({
            valorTe,
        }, () => {
            GuardarTeHist (est, datos.hid, valorTe.value, (resp) => {
                this.props.preloaderOk();
            })
        });
    }

    te = () => {
        let { datos } = this.props;
        
        let { valorTe, TeDisp } = this.state;
        
        if (datos.periodo !== "") return (
            <Select
                title = "Selecciona un Tipo de Evaluación"
                isSearchable ={true}
                value={valorTe}
                onChange={this.valorSelectTe}
                options={ TeDisp }
            />
        )
    }
    
    guardarNota = () => {
        let { datos, est } = this.props;
        let { nota, notaSelect } = this.state;
        

        if (nota === "" || nota === "0") return null;

        this.props.preloader();

        let letras = [
            "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
            "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
            "DIECINUEVE", "VEINTE"
        ];

        GuardarNotaHist (est, datos.hid, nota, notaSelect, (resp) => {
            if (resp[1].status !== "") toast[resp[1].status](resp[1].mensaje,{autoClose: 4000});
            this.setState({
                nota: resp[0],
                enLetras: letras[resp[0] - 1]
            }, () => {
                (resp[2].color === "#32704C") ? this.props.preloaderOk() : this.props.preloaderNok();
            })
        })
        
    }

    valorNota = (notaSelect) => { this.setState({
        notaSelect
    }, () => {
        this.guardarNota()
    }) }

    nota = (tipo) => {
        let { datos, num } = this.props;
        let { notaSelect, literales } = this.state;
        const customStyles = (base) => ({
            ...base,
            fontSize: 10,
        });

        switch (tipo) {
            case 0:
                return (
                    <Select
                        styles={{menu: customStyles}}
                        isSearchable ={true}
                        value={notaSelect}
                        onChange={this.valorNota}
                        options={literales}
                    />
                )
            case 1:
                if (datos.nota !== "")  return (
                    <input className="form-control" id = {`notaHistApl_${num}`} onKeyPress={this.tabEnter("notaHistApl_")} onBlur = {() => { this.guardarNota() }} maxLength ={3} onChange={this.cambiaValor("nota")} type= "text" value={this.state.nota} title="Agregar una calificacion al estudiante"/>
                )
            break;
            default: return null;
        }
    }

    enLetras = () => {
        let { datos } = this.props;
        let letras = [
            "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
            "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
            "DIECINUEVE", "VEINTE"
        ];

       this.setState({
            enLetras: letras[datos.nota - 1]
       })
    }

    render() {
        const styles = {
            minHeight: 40,
            fontSize: 10,
            padding: 3
        }

        let notaMat = (tipo) => {
            switch (tipo) {
                case 0:
                    return (
                        <td align="center" colSpan={2} style={styles}>{this.nota(tipo)}</td>
                    )
                case 1:
                    return (
                        <React.Fragment>
                            <td align="center" style={styles}>{this.nota(tipo)}</td>
                            <td align="center" style={styles}>{this.state.enLetras}</td>
                        </React.Fragment>
                    )
                default: return null;
            }
        }

        return (
            <React.Fragment>
                <tr>
                    <td align="center" style={styles} title="Selecciona un Periodo">{this.periodo()}</td>
                    <td align="center" style={styles}>{this.te()}</td>
                    {notaMat(this.props.datos.cuantitativo)}
                </tr>
            </React.Fragment>
        );
    }
}
 
export default MateriaHistApl


// WEBPACK FOOTER //
// ./src/views/Registros/HistoricoContent/MateriaHistApl.jsx